const JOIN_TIME_LOCALE_OPTIONS = {
  weekday: "short",
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  timeZone: "Africa/Cairo",
  hour12: true,
};

export function getAppointmentWindow(apt) {
  if (!apt || !apt.date) return { start: null, end: null };
  const start = new Date(apt.date);
  const end = apt.endDateTime
    ? new Date(apt.endDateTime)
    : new Date(start.getTime() + (apt.duration || 0) * 60000);
  return { start, end };
}

export function formatDurationHM(ms) {
  if (!isFinite(ms) || ms < 0) return "";
  const totalMinutes = Math.ceil(ms / 60000);
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;
  const hh = String(hours).padStart(2, "0");
  const mm = String(minutes).padStart(2, "0");
  return days > 0 ? `${days}d ${hh}:${mm}` : `${hh}:${mm}`;
}

export function getTimeInfo(apt, now) {
  const { start, end } = getAppointmentWindow(apt);
  if (!start || !end) return { label: "", tone: "ended" };

  const nowMs = new Date(now).getTime();
  const startMs = start.getTime();
  const endMs = end.getTime();

  if (nowMs < startMs) {
    return {
      label: `${formatDurationHM(startMs - nowMs)} till the appointment starts`,
      tone: "future",
    };
  }
  if (nowMs < endMs) {
    return {
      label: `${formatDurationHM(endMs - nowMs)} till the appointment ends`,
      tone: "live",
    };
  }
  return { label: "Ended", tone: "ended" };
}

export function formatJoinTime(iso) {
  if (!iso) return "\u2014";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "\u2014";
  return d.toLocaleString("en-US", JOIN_TIME_LOCALE_OPTIONS);
}

// YYYY-MM-DD for the Africa/Cairo calendar day, used by the date filters.
export function getCairoDateString(date = new Date()) {
  const parts = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: "Africa/Cairo",
  }).formatToParts(date);

  const read = (type) => parts.find((part) => part.type === type)?.value;
  return `${read("year")}-${read("month")}-${read("day")}`;
}

// The backend compares raw instants against appointment.date, and a plain
// "YYYY-MM-DD" resolves to UTC midnight — so a same-day range would only match
// rows at midnight. The admin list therefore sends the Cairo day's real bounds
// as ISO timestamps (same approach as the admin dashboard), using the fixed
// +02:00 offset the appointment models already assume.
const EGYPT_OFFSET = "+02:00";

export function getCairoDayRange(day) {
  const dayString =
    typeof day === "string" ? day : getCairoDateString(day ?? new Date());
  return {
    fromDate: new Date(`${dayString}T00:00:00${EGYPT_OFFSET}`).toISOString(),
    toDate: new Date(`${dayString}T23:59:59.999${EGYPT_OFFSET}`).toISOString(),
  };
}
